import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { RestorableEleve } from 'types/eleves';

export const ELEVES_TRASH_KEY = 'eleves_trash';

function fetchElevesTrash() {
  const requestURL = '/eleves/trash';
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }: { data: RestorableEleve[] }) => data || []);
}

export function useElevesTrash() {
  return useQuery({
    queryKey: [ELEVES_TRASH_KEY],
    queryFn: () => fetchElevesTrash(),
    placeholderData: [],
    refetchOnWindowFocus: false,
  });
}
